/**
 * Determina si el recibo es mensual o bimestral a partir del primer periodo.
 * @param {Array<{Periodo:string}>} rows  Lista que devuelve el backend.
 * @returns {"mensual" | "bimestral" | null}
 */
export function detectPeriodicity(rows) {
  if (!rows?.length) return null;

  try {
    const [iniRaw, finRaw] = rows[0].Periodo.split(" - ");
    const ini = new Date(iniRaw);
    const fin = new Date(finRaw);
    const dias = (fin - ini) / 86_400_000;

    return dias < 45 ? "mensual" : "bimestral";
  } catch {
    return null;
  }
}
